import { combineReducers } from 'redux';

import apiError from './apiError';
import byId from './byId';
import isLoading from './isLoading';

/**
 * @typedef {{
 *   byId: Record<string, import("modules/audits/types/stored-audit").StoredAudit>,
 *   isLoading: boolean,
 *   apiError: string,
 * }} AuditsDataReducer
 */

export default combineReducers({
  byId,
  isLoading,
  apiError,
});
